
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"0gaf8pjf1a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"14","height":"14"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h14v14H0z"}})]),_c('g',{attrs:{"mask":"url(#0gaf8pjf1a)"}},[_c('path',{attrs:{"d":"M2.916 12.25V2.917c0-.321.114-.596.343-.824.228-.229.503-.343.824-.343h3.5v1.167h-3.5v7.554l2.916-1.254 2.917 1.254V6.417h1.167v5.833L6.999 10.5l-4.083 1.75zm7-7V4.083H8.749V2.917h1.167V1.75h1.167v1.167h1.166v1.166h-1.166V5.25H9.916z","fill":"#757575"}})])])
          )
        }
      }
    